module.exports = __webpack_public_path__ + "static/media/single-div-kirby.2ad6905f.png";